import { domain } from 'modules/data';

export const compareByTextLowerCase = (
    beneficiaryA: domain.AirwallexBeneficiary,
    beneficiaryB: domain.AirwallexBeneficiary
) => beneficiaryA.text.localeCompare(beneficiaryB.text.toLowerCase());

export const compareByCurrencyAndText = (
    beneficiaryA: domain.AirwallexBeneficiary,
    beneficiaryB: domain.AirwallexBeneficiary
) =>
    beneficiaryA.accountCurrency.localeCompare(beneficiaryB.accountCurrency) ||
    beneficiaryA.text.toLowerCase().localeCompare(beneficiaryB.text.toLowerCase());
